import { useShopContext } from "../../context/shop/shop-context";

export const useSelectedShop = () => {
  const { shop, shops, requestShopChange, refetchShops } = useShopContext();
  return {
    selectedShopId: shop.shopId,
    selectedShop: shop.id,
    selectedShopValue: shop,
    shopList: shops,
    loading: false,
    onSelectedShopChange: requestShopChange,
    refetchShopList: refetchShops
  };
};
